import { AGENT_STATUS, PROFILE_FLYOUT } from '../utils'
import { FlyoutPanelPropsType } from '../utils/types/flyoutPanel.types'
import CustomRadioGroup from './CustomRadioGroup'

const FlyoutPanel = ({
  getInitials,
  user,
  logOutClick,
  handleRadioChange,
  defaultDisplay,
  setOpenProfilePanel,
  isAwsPermission,
  agentStatus,
}: FlyoutPanelPropsType) => {
  const displaySettingOptions = [
    {
      label: PROFILE_FLYOUT.COMFY,
      value: PROFILE_FLYOUT.COMFY,
    },
    {
      label: PROFILE_FLYOUT.COMPACT,
      value: PROFILE_FLYOUT.COMPACT,
    },
  ]
  const getStatusColor = (status: string) => {
    switch (status) {
      case AGENT_STATUS.AVAILABLE:
        return 'bg-success-25 border border-success-700'

      case AGENT_STATUS.OFFLINE:
        return 'bg-tertiary-200 border border-tertiary-200'

      case AGENT_STATUS.OUTBOUND:
        return 'bg-secondary-50 border border-secondary-700'

      case AGENT_STATUS.REPORTS:
        return 'bg-error-100 border border-error-500'

      case AGENT_STATUS.SYSTEM_DOWN:
        return 'bg-customColors-lightOrange border border-customColors-orange'

      case AGENT_STATUS.LUNCH:
      case AGENT_STATUS.BREAK:
        return 'bg-progress-25 border border-progress-500'

      default:
        return 'bg-border-25 border border-secondary-550'
    }
  }
  const capitalizeFirstLetter = (str?: string) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : ''
  const userName = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim()
  return (
    <div className="flex flex-col">
      <div className="flex gap-2.5 items-center pt-2.5 pb-3 px-4">
        <div className="left">
          {user && (
            <span className="flex items-center justify-center w-14 h-14 text-xs font-light rounded-full bg-profile-100 border text-profile-200">
              {getInitials(`${user?.first_name} ${user?.last_name}`)}
            </span>
          )}
        </div>
        <div className="right">
          <div className="flex gap-1.5 items-center">
            <div className="capitalize text-accent-800 text-xs font-semibold">
              {userName}
            </div>
            {isAwsPermission === 'true' ? (
              <div
                className={`px-2 py-1 rounded-full text-xs ${getStatusColor(
                  agentStatus ?? ''
                )}`}
              >
                <span>{agentStatus}</span>
              </div>
            ) : null}
          </div>
          <div className="font-primary text-accent-600 text-xs font-normal">
            {capitalizeFirstLetter(user?.user_id)}
          </div>
          <div className="flex items-center text-xs font-normal whitespace-nowrap">
            <div>{user?.profile}</div>
            <span className="mx-1">|</span>
            <div
              className="text-blue-600 cursor-pointer text-xs font-normal hover:underline"
              onClick={(e) => {
                e.preventDefault()
                setOpenProfilePanel?.(true)
              }}
            >
              {PROFILE_FLYOUT.VIEW_DETAILS}
            </div>
          </div>
        </div>
      </div>
      <hr className="border-accent-200" />
      <div className="p-3 pb-1">
        <div className="px-1 font-primary text-xs text-accent-800">
          {PROFILE_FLYOUT.DISPLAY_SETTINGS}
        </div>
        <CustomRadioGroup
          name={'display-settings'}
          options={displaySettingOptions}
          labelClasses=" text-xs font-primary font-light text-accent-800"
          optionClasses="pl-1"
          onChange={handleRadioChange}
          dataQaId="display-settings"
          defaultValue={defaultDisplay}
        />
      </div>
      <hr className="border-accent-200" />
      <div className="p-3">
        <button
          className="text-xs text-primary-500 w-auto"
          onClick={logOutClick}
          data-qa-id={'logout-click'}
        >
          {PROFILE_FLYOUT.LOGOUT}
        </button>
      </div>
    </div>
  )
}
export default FlyoutPanel
